import React, { useState } from "react";
const useKeyPress = function (targetKey, targetRef) {
    const [keyPressed, setKeyPressed] = useState(false);
    function downHandler({ key }) {
        if (key === targetKey) {
            setKeyPressed(true);
        }
    }
    const upHandler = ({ key }) => {
        if (key === targetKey) {
            setKeyPressed(false);
        }
    };
    React.useEffect(() => {
        if (!targetRef)
            return;
        if (!targetRef.current)
            return;
        targetRef.current.addEventListener("keydown", downHandler);
        targetRef.current.addEventListener("keyup", upHandler);
        return () => {
            var _a, _b;
            (_a = targetRef === null || targetRef === void 0 ? void 0 : targetRef.current) === null || _a === void 0 ? void 0 : _a.removeEventListener("keydown", downHandler);
            (_b = targetRef === null || targetRef === void 0 ? void 0 : targetRef.current) === null || _b === void 0 ? void 0 : _b.removeEventListener("keyup", upHandler);
        };
    });
    return keyPressed;
};
export default useKeyPress;
//# sourceMappingURL=useKeyPress.js.map